"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* -------------------------------------------------------------------------

	PUNITED.utils

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.utils) PUNITED.utils = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.utils;
  var props = {
    noScroll: {
      offset: {
        right: '--no-scroll--offset--right'
      }
    }
  };
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */

  ns.getScrollbarWidth = function () {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  };

  ns.preventScroll = function () {
    var offset = "".concat(ns.getScrollbarWidth(), "px");
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.paddingRight = offset;
    document.documentElement.style.setProperty(props.noScroll.offset.right, offset);
  };
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */


  ns.allowScroll = function () {
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
    document.documentElement.style.removeProperty(props.noScroll.offset.right);
  };

  ns.modal = function (modal) {
    var triggers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // const triggers = triggerSelector ? document.querySelectorAll(triggerSelector) : [];
    // const modal = document.querySelector(selector);
    var backdrop = modal.querySelector('.modal__backdrop');
    var inner = modal.querySelector('.modal_content');
    var outerNodes = modal.querySelectorAll('.modal__inner, .modal__backdrop, .modal_close_btn');
    var outerNodesArray = Array.from(outerNodes);
    var isTransitioning = false;

    var computedOptions = _objectSpread({
      open: false,
      closeByBackdrop: true,
      onOpenStart: null,
      onOpenEnd: null,
      onCloseStart: null,
      onCloseEnd: null
    }, options);

    if (computedOptions.open) {
      openModal();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        if (isTransitioning) {
          return;
        }

        openModal();
      });
    });
    modal.addEventListener('click', function (e) {
      if (isTransitioning) {
        return;
      }

      if (computedOptions.closeByBackdrop && outerNodesArray.includes(e.target)) {
        closeModal();
      }
    });

    function openModal() {
      isTransitioning = true;
      gsap.timeline({
        onStart: function onStart() {
          if (computedOptions.onOpenStart) {
            computedOptions.onOpenStart();
          }

          gsap.set(modal, {
            zIndex: 9999,
            opacity: 1
          });
          PUNITED.utils.preventScroll();
        },
        onComplete: function onComplete() {
          isTransitioning = false;

          if (computedOptions.onOpenEnd) {
            computedOptions.onOpenEnd();
          }
        }
      }).to(backdrop, {
        opacity: 1,
        duration: 0.25,
        ease: 'power4.out'
      }).to(inner, {
        opacity: 1,
        // scale: 1,
        duration: 0.5,
        ease: 'power4.out'
      }, '<');
    }

    function closeModal() {
      isTransitioning = true;
      gsap.timeline({
        onStart: function onStart() {
          if (computedOptions.onCloseStart) {
            computedOptions.onCloseStart();
          }
        },
        onComplete: function onComplete() {
          gsap.set(modal, {
            zIndex: -1,
            opacity: 0
          });

          if (computedOptions.onCloseEnd) {
            computedOptions.onCloseEnd();
          }

          isTransitioning = false;
          PUNITED.utils.allowScroll();
        }
      }).to(inner, {
        opacity: 0,
        // scale: 0.9,
        duration: 0.25,
        ease: 'power2.out'
      }).to(backdrop, {
        opacity: 0,
        duration: 0.25,
        ease: 'power2.out'
      }, '<');
    }

    return {
      open: openModal,
      close: closeModal
    };
  };

  ns.headLine = function (dataPc, dataSp) {
    var container = document.querySelector('.page_head');
    var img = container.querySelector('.page_head__bg img');
    var lineContainer = container.querySelector('.page_head__line');
    var linePath = lineContainer.querySelector('path');
    var tl = gsap.timeline({
      paused: true
    }).to(linePath, {
      'stroke-dashoffset': function strokeDashoffset() {
        return PUNITED.utils.getLineLength(linePath) * 2 - 1;
      },
      duration: 1.5
    });
    resizeLine();
    var observer = new ResizeObserver(function () {
      resizeLine();

      if (tl.isActive()) {
        tl.pause().invalidate().resume();
      }
    });
    observer.observe(container);

    if (img.complete) {
      tl.play();
    } else {
      img.addEventListener('load', function () {
        tl.play();
      });
    }

    function resizeLine() {
      var isSp = PUNITED.common.mediaQuery.matches;
      var data = isSp ? dataSp : dataPc;
      var svg = lineContainer.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = container.offsetWidth;
      var canvasHeight = container.offsetHeight;
      var ratioX = canvasWidth / (isSp ? 345 : 1340);
      var ratioY = canvasHeight / (isSp ? 200 : 350);
      var width = data.width * ratioX;
      var height = data.height * ratioY;
      var ratio = [ratioX, ratioY];
      var d = data.d.map(function (segment) {
        var points = segment.points.map(function (point) {
          return point.map(function (v, i) {
            return v * ratio[i];
          }).join(',');
        }).join(' ');
        return "".concat(segment.command, " ").concat(points);
      }).join(' ');
      var translate = data.translate.map(function (v, i) {
        return v * ratio[i];
      }).join(' ');
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', d);
      path.setAttribute('transform', "translate(".concat(translate, ")"));
      var length = PUNITED.utils.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "".concat(tl.progress() === 1 ? length * -2 + 1 : length);
    }
  };
  /* -----------------------------------------------------
  	Image slider
  ----------------------------------------------------- */


  ns.imgSlider = function () {
    var containers = document.querySelectorAll('.img_slider');
    containers.forEach(function (container) {
      var slider = container.querySelector('.splide');
      var nav = slider.querySelector('.img_slider__nav');
      var slides = slider.querySelectorAll('.splide__slide');
      var single = slides.length === 1;
      nav.style.display = single ? 'none' : '';
      var slideSpeed = 2000;
      var slideDelay = 3000;
      var splide = new Splide(slider, {
        type: 'fade',
        rewind: true,
        speed: slideSpeed,
        easing: 'ease',
        interval: slideSpeed + slideDelay,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false
      });
      splide.mount();
    });
  };

  ns.anchorMenu = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.page_menu__link';
    var mq = PUNITED.common.mediaQuery;
    var images = Array.from(document.querySelectorAll('.wp-block-image:not(.sp_none) img[loading="lazy"]'));
    var completeImages = images.map(function (image) {
      return image.complete;
    });

    if (mq.matches) {
      images.forEach(function (image) {
        return image.loading = 'eager';
      });
    }

    var currentTarget;
    var links = document.querySelectorAll(selector);
    links.forEach(function (link) {
      var href = link.getAttribute('href');

      if (!href.startsWith('#')) {
        return;
      }

      var id = href.replace('#', '');
      var target = document.getElementById(id);

      if (!target) {
        return;
      }

      init(link, href, target);
    });
    var paramKey = 'anc';
    var params = new URLSearchParams(window.location.search);

    if (params.has(paramKey)) {
      currentTarget = document.getElementById(params.get(paramKey));

      if (!currentTarget) {
        return;
      }

      handleCurrentTarget();
    }

    function init(link, href, target) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        currentTarget = target;
        handleCurrentTarget();
      });
    }

    function handleCurrentTarget() {
      if (!mq.matches || isEveryImageLoaded()) {
        scrollToCurrent();
        return;
      }

      preloadImages();
    }

    function scrollToCurrent() {
      var _currentTarget;

      (_currentTarget = currentTarget) === null || _currentTarget === void 0 ? void 0 : _currentTarget.scrollIntoView({
        behavior: 'smooth'
      });
      currentTarget = null;
    }

    function preloadImages() {
      images.forEach(function (image, i) {
        if (image.complete) {
          completeImages[i] = image.complete;
          return;
        }

        image.addEventListener('load', function () {
          completeImages[i] = image.complete;

          if (isEveryImageLoaded()) {
            scrollToCurrent();
          }
        });
      });

      if (isEveryImageLoaded()) {
        scrollToCurrent();
      }
    }

    function isEveryImageLoaded() {
      return completeImages.every(function (complete) {
        return complete;
      });
    }
  };
  /* -----------------------------------------------------
  	Wrapper for path.getTotalLength()
  	Round the result of getTotalLength() because Safari will screw you over if you use decimal value in stroke
  ----------------------------------------------------- */


  ns.getLineLength = function (line) {
    return Math.floor(line.getTotalLength());
  };

  ns.handleProductCategoryNav = function () {
    var form = document.querySelector('.products_cat_nav');
    var select = form.querySelector('select');
    var labels = form.querySelectorAll('.products_l1_cat_item__label');
    var inputs = form.querySelectorAll('.products_l1_cat_item__input');
    var boxes = form.querySelectorAll('.products_cat_box');
    select.addEventListener('change', handleSelectChange);
    labels.forEach(function (label) {
      label.addEventListener('click', handleLabelClick);
    });
    inputs.forEach(function (input) {
      input.addEventListener('change', handleInputChange);
    }); // reset();

    function handleLabelClick(e) {
      var input = e.currentTarget.previousElementSibling;

      if (input.checked) {
        e.preventDefault();
        reset();
      }
    }

    function handleInputChange(e) {
      var checked = e.currentTarget.checked;
      var value = e.currentTarget.value;
      select.value = value;
      changeBox(value, checked);
    }

    function handleSelectChange(e) {
      var value = e.currentTarget.value;
      var checked = value !== '';
      inputs.forEach(function (input) {
        if (input.value === value) {
          input.checked = checked;
        }
      });

      if (checked) {
        changeBox(value, checked);
      } else {
        reset();
      }
    }

    function changeBox(value, checked) {
      var id = "l1_cat_box_".concat(value);
      boxes.forEach(function (box) {
        if (checked && box.id === id) {
          box.style.display = '';
        } else {
          box.style.display = 'none';
        }
      });
    }

    function reset() {
      inputs.forEach(function (input) {
        input.checked = false;
      });
      boxes.forEach(function (box) {
        box.style.display = 'none';
      });
    }
  };
})();